// libs
import React from 'react';
import { css } from '@emotion/css';

import { cn } from '@lyearn/style';
// components
import { Box, Typography } from '@lyearn/ui';
import formatScore from '@/modules/corporate/modules/exercise/helpers/formatScore';

// types
import { AverageScoreProps } from '../types';
// helpers
import { getColors } from './util';

const averageScoreStyles = css`
  border-radius: 6px;
`;

function AverageScore(props: AverageScoreProps) {
  const { className, score, showNA } = props;

  if ((score === null || score === undefined) && !showNA) {
    return null;
  }

  const { backgroundColor, borderColor, textColor, variant } = getColors(score);

  return (
    <Box
      className={cn(
        'flex h-40 w-40 items-center justify-center border fill-current me-16',
        className,
        backgroundColor,
        borderColor,
        averageScoreStyles,
      )}>
      <Typography className={textColor} variant={variant}>
        {formatScore(score, showNA)}
      </Typography>
    </Box>
  );
}

export default React.memo(AverageScore);
